import { InitializeApplication } from '@dealstack/frontend/investor/components/global/InitializeApplication/InitializeApplication';
import { createRoot } from 'react-dom/client';
import '@dealstack/frontend/shared/index.css';
import whyDidYouRender from '@welldone-software/why-did-you-render';
import React from 'react';
import { configureBackendClient } from '@dealstack/frontend/api/backendClient.config';
import { startHostedAuthIfOnLoginRoute } from '@dealstack/frontend/shared/pages/AuthStart/startHostedAuth';
import { ApplicationType } from '@dealstack/shared/lib/generated';

if (import.meta.env.MODE === 'development') {
	whyDidYouRender(React, { logOnDifferentValues: true });
}

// Configure the Hey API generated backend client (base URL, cookie auth,
// request id, payload unwrapping) once, at startup, before React mounts — so
// it's configured before any component renders or any generated SDK call runs.
configureBackendClient();

if (!startHostedAuthIfOnLoginRoute(ApplicationType.INVESTOR)) {
	const container = document.getElementById('root');
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	const root = createRoot(container!);
	root.render(<InitializeApplication />);
}
